<template lang="pug">
el-row
  el-col(:sm="6", :offset="9")
    el-form(@submit.prevent.native="submit")
      el-alert(v-if="error", :title="error", type="error", :closable="false")
      .well
        el-form-item
          el-input(v-model="credentials.username", placeholder="потребителско име", autofocus)
        el-form-item
          el-input(v-model="credentials.password", placeholder="парола", type="password")
        el-button(native-type="submit", type="primary") Влез
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      error: ''
    }
  },
  methods: {
    submit() {
      this.$auth.login({
        data: {
          username: this.credentials.username,
          password: this.credentials.password
        },
        rememberMe: true,
        redirect: '/',
        success: (response) => {
          // console.log(response);
        },
        error: (error) => {
          console.log(error.response)
          this.error = error.response.data.error ? error.response.data.error : error.response.data
        }
      })
    }
  }
}
</script>